// extracted by mini-css-extract-plugin
module.exports = {"login":"complete-form_login__Ox9Ef","blueBorder":"complete-form_blueBorder__ZIvWj","button":"complete-form_button__1nejp"};